var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFdfManufacturingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "#0066CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 27.0834L27.0833 18.7501C27.4727 18.3685 27.7826 17.9135 27.995 17.4114C28.2075 16.9092 28.3183 16.37 28.321 15.8248C28.3238 15.2796 28.2184 14.7392 28.0111 14.235C27.8037 13.7308 27.4984 13.2727 27.1129 12.8871C26.7274 12.5016 26.2693 12.1963 25.765 11.989C25.2608 11.7816 24.7205 11.6763 24.1753 11.679C23.6301 11.6818 23.0908 11.7926 22.5887 12.005C22.0866 12.2175 21.6316 12.5274 21.25 12.9168L12.9166 21.2501C12.5272 21.6317 12.2174 22.0867 12.0049 22.5888C11.7924 23.0909 11.6816 23.6302 11.6789 24.1754C11.6761 24.7206 11.7815 25.2609 11.9889 25.7652C12.1962 26.2694 12.5015 26.7275 12.887 27.113C13.2725 27.4985 13.7307 27.8038 14.2349 28.0112C14.7391 28.2186 15.2795 28.3239 15.8247 28.3212C16.3699 28.3184 16.9091 28.2076 17.4112 27.9951C17.9133 27.7827 18.3684 27.4728 18.75 27.0834Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0834 17.0833L22.9167 22.9166",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdfManufacturingIcon);
export default __webpack_public_path__ + "static/media/FDF Manufacturing-icon.5176aeb7520864ff1f2f981167a52fdb.svg";
export { ForwardRef as ReactComponent };